import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteEvent = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, { tripId: string; eventId: string }>({
		mutationFn: async ({ tripId, eventId }) => {
			await api.delete(`/trips/${tripId}/events/${eventId}`)
		},
		onSuccess: (_, variables) => {
			// Invalidate and refetch events for this trip
			queryClient.invalidateQueries({ queryKey: ['events', variables.tripId] })
		},
	})
}
